import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PropTypes } from "prop-types";

const SingleDateFilter = ({
  fixedDate,
  placeholder,
  subLabel,
  onChange,
  label,
}) => {
  return (
    <div className="form-date-wrapper">
      <p>
        <span>{subLabel}</span> {label}
      </p>
      <DatePicker
        selected={fixedDate}
        onChange={onChange}
        placeholderText={placeholder}
      />
    </div>
  );
};

SingleDateFilter.propTypes = {
  fixedDate: PropTypes.instanceOf(Date),
  placeholder: PropTypes.string,
  subLabel: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string
};

export default SingleDateFilter;
